import { GreenerUnit } from "types";
import { canSeeOperatorChat } from "utils/authorization";
import { DEVICE_TYPES } from "utils/constants";

export const shouldRenderOperatorChat = (userRole: Record<string, string | boolean> | undefined, asset: GreenerUnit | undefined, isChatEnabled: boolean) => {
  return (
    canSeeOperatorChat(userRole) &&
    isChatEnabled &&
    !!asset &&
    asset.watcherType?.deviceType?.externalIdentifier === DEVICE_TYPES.BATTERY
  );
};
